import { useGetDynamicPages, useGetStaticPages } from 'api/hooks';
import { DynamicPage } from 'proto/web_app_grpc_pb';
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ApiDetailsPage } from './ApiDetailsPage';
import { ApiKeysCatalogPage } from './ApiKeysCatalogPage';
import { ApisCatalogPage } from './ApisCatalogPage';
import { DynamicPageComponent } from './DynamicPage';
import { ErrorBoundary } from './ErrorBoundary';
import { Footer } from './Footer';
import { Header } from './Header';
import { HomePage } from './HomePage';
import './MainContent.css';
import { MarkdownDisplayPage } from './MarkdownDisplayPage';

export const MainContent = () => {
  const { staticPages } = useGetStaticPages();
  const { dynamicPages } = useGetDynamicPages();

  return (
    <div className='main-container'>
      <Header />
      <div className='main-container-content'>
        <Switch>
          <Route path='/apis/' exact>
            <ErrorBoundary fallback={<div>There was an error trying to get to the api pages.</div>}>
              <ApisCatalogPage />
            </ErrorBoundary>
          </Route>
          <Route path='/apis/:apiproductnamespace/:apiproductname'>
            <ErrorBoundary fallback={<div>There was an error trying to get to the api pages.</div>}>
              <ApiDetailsPage />
            </ErrorBoundary>
          </Route>
          <Route path='/user-controls/'>
            <ErrorBoundary fallback={<div>There was an error trying to get to the user controls.</div>}>
              <div>User Controls</div>
            </ErrorBoundary>
          </Route>
          <Route path='/keys/'>
            <ErrorBoundary fallback={<div>There was an error retrieving API key information.</div>}>
              <ApiKeysCatalogPage />
            </ErrorBoundary>
          </Route>

          {staticPages?.map(page => (
            <Route path={page.path} key={page.path}>
              <ErrorBoundary
                fallback={<div>There was an error trying to reach the markdown page "{page.navigationLinkName}".</div>}>
                <MarkdownDisplayPage />
              </ErrorBoundary>
            </Route>
          ))}
          {dynamicPages?.map((page: DynamicPage.AsObject) => (
            <Route path={page?.path} key={page?.path}>
              <ErrorBoundary
                fallback={<div>There was an error trying to reach the page "{page?.navigationLinkName}".</div>}>
                <DynamicPageComponent page={page} />
              </ErrorBoundary>
            </Route>
          ))}

          <Route path='/'>
            <ErrorBoundary fallback={<div>There was an error trying to get to the home page.</div>}>
              <HomePage />
            </ErrorBoundary>
          </Route>
        </Switch>
      </div>

      <Footer />
    </div>
  );
};
